var _circle, _circle2, _rect, _g, _mask, _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptySearch = function SvgEmptySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 135,
    viewBox: "0 0 124 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.694,
    cy: 76.3698,
    r: 58.3073,
    fill: "#EFF4F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.3073,
    cy: 69.2761,
    r: 57.9134,
    stroke: "#DCE5E1",
    strokeWidth: 0.787937
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.8338,
    y: 53.5916,
    width: 52.2878,
    height: 36.5722,
    rx: 5.89881,
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1471_25664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2973 61.5917H43.7945C43.3546 61.5917 43 61.2343 43 60.7972C43 60.3601 43.3574 60 43.7945 60H60.2973C60.7372 60 61.0918 60.3574 61.0918 60.7945C61.0918 61.2316 60.7344 61.589 60.2973 61.589V61.5917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4356 66.738H43.7945C43.3546 66.738 43 66.3806 43 65.9435C43 65.5064 43.3574 65.149 43.7945 65.149H53.4328C53.8727 65.149 54.2273 65.5064 54.2273 65.9435C54.2273 66.3806 53.8699 66.738 53.4328 66.738H53.4356Z",
    fill: "white"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-1_1471_25664",
    maskUnits: "userSpaceOnUse",
    x: 67.3086,
    y: 67.3558,
    width: 25,
    height: 25,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 67.3086,
    y: 67.3558,
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9181 72.5488C92.1768 76.8075 92.1768 83.7056 87.9181 87.9643C83.6594 92.223 76.7613 92.223 72.5026 87.9643C68.2439 83.7056 68.2439 76.8075 72.5026 72.5488C76.7613 68.2901 83.6651 68.2929 87.9181 72.5488Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9181 72.5488C92.1768 76.8075 92.1768 83.7056 87.9181 87.9643C83.6594 92.223 76.7613 92.223 72.5026 87.9643C68.2439 83.7056 68.2439 76.8075 72.5026 72.5488C76.7613 68.2901 83.6651 68.2929 87.9181 72.5488Z",
    fill: "#EFF4F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0837 73.3832C90.8816 77.1811 90.8816 83.332 87.0837 87.1299L88.7525 88.7987C93.472 84.0792 93.472 76.4339 88.7525 71.7144L87.0837 73.3832ZM87.0837 87.1299C83.2859 90.9278 77.1349 90.9278 73.337 87.1299L71.6682 88.7987C76.3877 93.5182 84.033 93.5182 88.7525 88.7987L87.0837 87.1299ZM73.337 87.1299C69.5391 83.332 69.5391 77.1811 73.337 73.3832L71.6682 71.7144C66.9487 76.4339 66.9487 84.0792 71.6682 88.7987L73.337 87.1299ZM73.337 73.3832C77.1348 69.5854 83.2913 69.5882 87.0835 73.3829L88.7528 71.7147C84.0389 66.9977 76.3878 66.9949 71.6682 71.7144L73.337 73.3832Z",
    fill: "#1B382F",
    mask: "url(#path-6-outside-1_1471_25664)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8853 94.9272L88.2217 88.4276",
    stroke: "#1B382F",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 104.677,
    y1: 1.71479,
    x2: 113.591,
    y2: 10.6293,
    stroke: "#FF5F5A",
    strokeWidth: 3.15175
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 104.586,
    y1: 10.8022,
    x2: 113.5,
    y2: 1.88771,
    stroke: "#FF5F5A",
    strokeWidth: 3.15175
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 78.5876,
    y1: 18.0896,
    x2: 83.1951,
    y2: 22.697,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 78.5442,
    y1: 22.7878,
    x2: 83.1516,
    y2: 18.1804,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 7.5603,
    y1: 53.0974,
    x2: 12.1677,
    y2: 57.7048,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 7.51685,
    y1: 57.7957,
    x2: 12.1243,
    y2: 53.1882,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.747,
    y: 49.4792,
    width: 51.6099,
    height: 18.5165,
    rx: 2.95476,
    transform: "rotate(-25.1706 66.747 49.4792)",
    fill: "white",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72.4707,
    y: 51.5674,
    width: 9.45524,
    height: 9.45524,
    rx: 1.57587,
    transform: "rotate(-25.1706 72.4707 51.5674)",
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 85.0332,
    y: 46.1494,
    width: 26.7898,
    height: 3.15175,
    rx: 0.787937,
    transform: "rotate(-25.1706 85.0332 46.1494)",
    fill: "#EFF4F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.3457,
    y: 51.0635,
    width: 17.3346,
    height: 3.15175,
    rx: 0.787937,
    transform: "rotate(-25.1706 87.3457 51.0635)",
    fill: "#EFF4F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.192,
    y: 65.979,
    width: 40.7331,
    height: 14.6142,
    rx: 2.33205,
    transform: "rotate(18.8809 17.192 65.979)",
    fill: "white",
    stroke: "#1B382F",
    strokeWidth: 0.93282
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2949,
    y: 70.3057,
    width: 7.46256,
    height: 7.46256,
    rx: 1.24376,
    transform: "rotate(18.8809 19.2949 70.3057)",
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 0.93282
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3926,
    y: 74.1299,
    width: 21.1439,
    height: 2.48752,
    rx: 0.62188,
    transform: "rotate(18.8809 29.3926 74.1299)",
    fill: "#EFF4F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0059,
    y: 78.1846,
    width: 13.6814,
    height: 2.48752,
    rx: 0.62188,
    transform: "rotate(18.8809 28.0059 78.1846)",
    fill: "#EFF4F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1471_25664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.0918,
    height: 6.73804,
    fill: "white",
    transform: "translate(43 60)"
  })))));
};
export default SvgEmptySearch;